import { render, staticRenderFns } from "./zBusca.vue?vue&type=template&id=29104858&scoped=true"
import script from "./zBusca.vue?vue&type=script&lang=js"
export * from "./zBusca.vue?vue&type=script&lang=js"
import style0 from "./zBusca.vue?vue&type=style&index=0&id=29104858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29104858",
  null
  
)

export default component.exports